import React, { useState, useEffect } from "react";
import { DownloadOutlined, EyeOutlined, SendOutlined, CheckCircleOutlined, CloseCircleOutlined, CheckCircleTwoTone, HourglassTwoTone, UploadOutlined, SettingOutlined, TeamOutlined,
         LockOutlined, CalendarOutlined, CheckOutlined, LeftOutlined, FileTextOutlined, FileExclamationOutlined } from "@ant-design/icons";
import { Form, Select, DatePicker, Table, Button, Modal, message, Input, Upload, Radio, Dropdown, Menu, Checkbox, Tooltip } from 'antd';
import dayjs from 'dayjs'; 
import axios from '../../services/axios';
import moment from "moment";
import { DESIGN_MANAGER, PROJECT_MANAGER, DOCUMENT_CONTROLLER, DRAUGHTSMAN, CONSULTANT_DOCUMENT_CONTROLLER, ENGINEER, QUANTITY_SURVEYOR, PLANNING_ENGINEER, HEALTH_SAFETY_ENVIRONMENT, 
  CONSULTANT_ENGINEER, CONSULTANT_SITE_ENGINEER, CONSULTANT_QUANTITY_SURVEYOR, CONSULTANT_SUPERVISOR, CONSULTANT_HEALTH_SAFETY_ENVIRONMENT, CONSULTANT_DESIGN_MANAGER, PROCUREMENT_MANAGER, QAQC_MANAGER, CONTRACT_MANAGER, 
  CONSULTANT_PROJECT_MANAGER, CONSULTANT_QAQC_MANAGER, CONSULTANT_CONTRACT_MANAGER, CONSULTANT_PURCHASING_MANAGER, EMPLOYER_PROJECT_MANAGER, EMPLOYER_DESIGN_MANAGER, EMPLOYER_QAQC_MANAGER, EMPLOYER_CONTRACT_MANAGER, EMPLOYER_PROCUREMENT_MANAGER,
  SUBCONTRACTOR_DOCUMENT_CONTROLLER
} from "../../constants/role";
import { useNavigate, useLocation } from 'react-router-dom';
import { CONSULTANT, CONTRACTOR, SUBCONTRACTOR } from "../../constants/userType";

const { Option } = Select;

const ViewDocumentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const [documents, setDocuments] = useState([]);
  const [searchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timeline, setTimeline] = useState(dayjs().add(1, 'day').format("YYYY-MM-DD"));
  const [filters, setFilters] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedTitle] = useState(""); 
  const [pendingCount, setPendingCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [originalDocUrl, setOriginalDocUrl] = useState(null);
  const [isComparisonView, setIsComparisonView] = useState(false);
  const [filteredDocuments, setFilteredDocuments] = useState(documents);
  const [rejectReason, setRejectReason] = useState("");
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isRejectLoading, setIsRejectLoading] = useState(false); 
  const user = localStorage.getItem('user');
  const role = JSON.parse(localStorage.getItem('role'))[0];
  const projectName = JSON.parse(localStorage.getItem('Project'))        
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [approvalType, setApprovalType] = useState("approve");
  const [approvalComment, setApprovalComment] = useState("");
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem('userType');
  const [selectedRole, setSelectedRole] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [fetchingRoles, setFetchingRoles] = useState(false);
  const [workflowData, setWorkflowData] = useState(null);
  const [sendToOptions, setSendToOptions] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [modalHandled, setModalHandled] = useState(false);
  const isSingleSelection = selectedRowKeys.length === 1;
  const hasFetched = React.useRef(false);
  const [rejectSendTo, setRejectSendTo] = useState("");
  const [rejectOptions, setRejectOptions] = useState([]);

  const isAllowedRole =
    role.includes(CONSULTANT_DOCUMENT_CONTROLLER) ||
    role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER) ||
    role.includes(DOCUMENT_CONTROLLER);

  const fromConsultant = role.includes(CONSULTANT_DOCUMENT_CONTROLLER);
  const fromContractor = role.includes(DOCUMENT_CONTROLLER);
  const fromSubcontractor = role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER);

  const toConsultant = selectedRole?.includes(CONSULTANT_DOCUMENT_CONTROLLER);
  const toContractor = selectedRole?.includes(DOCUMENT_CONTROLLER);
  const toSubcontractor = selectedRole?.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER);

  // SIMPLE FLOW
  const isSimpleApproval =
    (fromSubcontractor && toContractor) ||
    (fromContractor && toConsultant);

  // FULL FLOW
  const isFullFlow =
    (fromConsultant && toContractor) ||
    (fromContractor && toSubcontractor);

  // DC FLOW (your extra condition)
  const isDCFlow =
    (fromConsultant || fromSubcontractor) &&
    selectedRole?.includes(DOCUMENT_CONTROLLER);

  useEffect(() => {
    setFilteredDocuments(
      documents.filter((doc) => {
        const matchesSearchTerm = searchTerm ? doc.title.toLowerCase() === searchTerm.toLowerCase() : true;
        const matchesSelectedTitle = selectedTitle ? doc.title === selectedTitle : true;
        return matchesSearchTerm && matchesSelectedTitle;
      })
    );
  }, [searchTerm, selectedTitle, documents]); 

  useEffect(() => {
    const pendingAndRejectedDocs = documents.filter(
      (doc) =>
        doc.status?.trim() === "Pending" ||
        doc.status?.trim() === "Rejected"
    );
    setFilteredDocuments(pendingAndRejectedDocs);
  }, [documents]);

  useEffect(() => {
    if (
        location.state?.openSendModal &&
        location.state?.selectedDocuments?.length > 0 &&
        !modalHandled
    ) {
        const selectedDoc = location.state.selectedDocuments[0];
        setSelectedDocuments(location.state.selectedDocuments);
        setSelectedFile(selectedDoc);

        // Attach transmittal file
        if (location.state?.transmittalFile) {
            const t = location.state.transmittalFile;
            const transmittalFile = [{
                uid: '-1',
                name: t.name || 'transmittal.pdf',
                status: 'done',
                url: t.url,
                originFileObj: t.file,
            }];
            setFileList(transmittalFile);
            form.setFieldsValue({ file: transmittalFile });
        }

        // ❗ Correct role fetching logic
        if (role.includes(DOCUMENT_CONTROLLER) || role.includes(CONSULTANT_DOCUMENT_CONTROLLER) || role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER)) {
            fetchAvailableRoles(selectedDoc.documentReference);
        } else {
            sendToUser(selectedDoc.documentReference);
        }

        setIsModalOpen(true);
        setModalHandled(true);
    }
}, [location.state, documents]);

  const handleDownload = (file) => {
    if (!file) {
      console.error("File is undefined or null");
      return;
    }
    
    fetch(file)
      .then(response => response.blob()) 
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const temp = file[file.length - 1];
        link.download = temp.split("/").pop(); 
        link.click();
        window.URL.revokeObjectURL(url); 
      })
      .catch(error => console.error("Error downloading file:", error));
  };
  
  const handlePreview = (file, originalDoc = null, isComparison = false) => {
    if (file) {
      const fileToPreview = Array.isArray(file) ? file[file.length - 1] : file;
      setFileUrl(fileToPreview);
      if(isComparison && originalDoc){
        setOriginalDocUrl(originalDoc);
        setIsComparisonView(true);
      } else {
        setOriginalDocUrl(null);
        setIsComparisonView(false);
      }
      setIsModalVisible(true); 
    } else {
      console.error("File URL is invalid or missing.");
    }
  };

  const handleApproveWithComment = () => {
    if (!selectedRecord) return;
    if (approvalType === "approveWithComment" && !approvalComment.trim()) {
      message.error("Please enter a comment before submitting.");
      return;
    }
    approveByRole(selectedRecord.code, approvalComment);
  };

  const handleOpenApproveModal = (record) => {
    setSelectedRecord(record);  
    setIsApproveModalOpen(true);
  };  

  const handleRejectedDocPreview = (record) => {
    if (["Revise & Resubmit", "Rejected", "Under Internal Review"].includes(record.status) && record.rejectionReasons && 
    record.rejectionReasons[record.rejectionReasons?.length - 1]?.rejectedDocumentUrl && record.documentUrl) {
      handlePreview(
        record.rejectionReasons[record.rejectionReasons.length - 1].rejectedDocumentUrl, 
        record.documentUrl[record.documentUrl.length - 1],
        true
      );
    } else {
      console.warn("No rejected document available for comparison")
    }
  };

  const handleReupload = (record) => {
    navigate('/home/upload-document',{
      state: { 
        prefillData: {
           projectName: record.projectName,
           type: record.type,
           category: record.category,
           originalDocumentCode: record.code,
           documentReference: record.documentReference,
           documentDescription: record.documentDescription,
           discipline: record.discipline,
          }
        }
       });
    };


  const handleCancel = () => {
    setIsModalVisible(false);
    setIsComparisonView(false);
    setOriginalDocUrl(null); 
  };
  
  const handleOpenModal = (file) => {
    const newDocument = {
      documentReference: file.documentReference,
      documentDescription: file.documentDescription,
      code: file.code,
    };

    setSelectedDocuments((prev) => {
      if (prev.some(doc => doc.code === newDocument.code)) {
        return prev;
      }
      return [...prev, newDocument];
    });

    setSelectedFile(file);
    setIsModalOpen(true);
    setModalHandled(false);

    const transmittal = location.state?.transmittalFile;
    if (transmittal && role.includes(CONSULTANT_DOCUMENT_CONTROLLER)) {
      const transmittalFile = [{
        uid: '-1',
        name: transmittal.name || 'transmittal.pdf',
        status: 'done',
        url: transmittal.url,
        originFileObj: transmittal.file,
      }];
      setFileList(transmittalFile);
      form.setFieldsValue({ file: transmittalFile });
    } else {
      setFileList([]);
      form.setFieldsValue({ file: undefined });
    }

    if(role.includes(DOCUMENT_CONTROLLER) || role.includes(CONSULTANT_DOCUMENT_CONTROLLER) || role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER)){
      fetchAvailableRoles(file.documentReference);
    } else {
      sendToUser(file.documentReference);
    }
  };

  const handleUploadModalOpen = async (record) => {
    setSelectedFile(record);
    setIsUploadModalOpen(true);

    // ✅ RESET FIRST (VERY IMPORTANT)
    setRejectOptions([]);
    setRejectSendTo("");

    if (userType === CONSULTANT) {
      try {
        const res = await axios.post("/send-option-to-Consultant", {
          documentReference: record.documentReference, role: role
        });

        const roles = [
          ...(res.data.previousRoles || []),
          ...(res.data.nextRoles || []),
        ];

        // console.log("API roles:", roles);

        // ✅ CLEAN + UNIQUE
        const cleanRoles = [...new Set(roles.filter(Boolean))];

        setRejectOptions(cleanRoles);

      } catch (err) {
        message.error("Failed to fetch roles");
      }
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    form.resetFields();
    setTimeline("");
    setFileList([]);
    setAvailableRoles([]);
    setRoles([]);
    setWorkflowData(null);
    setSelectedRole(null);
    setSelectedDocuments([]);
    setSelectedFile(null);
    setModalHandled(false);
    navigate(location.pathname, { replace: true, state: {} });
  };

  const handleUploadModalClose = () => {
    setIsUploadModalOpen(false);
    setFileList([]);
    setRejectReason(""); 
    fetchDocuments();
    fetchDocumentCount();
    setSelectedFile(null);
  };

  const fetchAvailableRoles = async (documentReference) => {
    setFetchingRoles(true);
    try {
      let response;

      if (role.includes("Consultant")) {
        // 👇 Call your consultant API
        response = await axios.post("/send-option-to-Consultant", {
          documentReference, role,
        });

        if (response.data) {
          const roles = [
            ...(response.data.previousRoles || []),
            ...(response.data.nextRoles || []),
          ];
          const uniqueRoles = [...new Set(roles)];

          setRoles(uniqueRoles.map((r) => ({ role: r })));
        }
      } else {
        response = await axios.post("/send-by-documentcontroller", {
          documentReference, role
        });

        if (response.data) {
          const roles = response.data.availableRoles || [];
          const filteredRoles = roles.filter((e)=> e !== role);
          setAvailableRoles(filteredRoles);
          setRoles(filteredRoles);
          setWorkflowData(response.data.workflow);
        }
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || "Failed to fetch available roles";
      message.error(errorMsg);
      setAvailableRoles([]);
      setRoles([]);
    } finally {
      setFetchingRoles(false);
    }
  };

  const sendDocument = async (values) => {
    if (!selectedDocuments.length && selectedFile) {
      setSelectedDocuments([{
        documentReference: selectedFile.documentReference,
        documentDescription: selectedFile.documentDescription,
        code: selectedFile.code,
      }]);
    }
    values.code = selectedFile.code;
    values.user = user;
    values.docRef = selectedFile.documentReference;
    values.description = selectedFile.documentDescription;
    values.projectName = selectedFile.projectName;
    values.consulWithStatus = values.consulWithStatus || location.state?.consulWithStatus;
    values.role = Array.isArray(values.sendTo) ? values.sendTo[0] : values.sendTo;
    if (!values.timeline) {
      values.timeline = timeline;
    }
    values.selectedDocuments = selectedDocuments;
    setLoading(true);
    try {
      let endpoint = '';

      // 🔥 FIX: EMAIL FIRST
      if (values.sendTo === 'email') {
        endpoint = 'send-to-email';

      } else if (
        role.includes(CONSULTANT_DOCUMENT_CONTROLLER) ||
        role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER)
      ) {

        if (values?.sendTo?.includes(DOCUMENT_CONTROLLER)) {
          endpoint = 'send-back-to-dc';
        } else {
          endpoint = 'send-to-consultant-users';
        }

      } else if (
        (role.includes(DOCUMENT_CONTROLLER) && userType === CONTRACTOR) ||
        (role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER) && userType === SUBCONTRACTOR)
      ) {

        if (
          values?.sendTo?.includes("Consultant") ||
          values?.sendTo?.includes("Subcontractor")
        ) {
          endpoint = 'send-to-dc-consultant';
        } else {
          endpoint = 'send-to-next-user';
        }

      } else {
        endpoint = 'send-to-next-user';
      }

      let response;

      if (endpoint === 'send-to-dc-consultant' || endpoint === 'send-back-to-dc' || endpoint === 'send-to-email') {
        if (fileList.length === 0) {
          message.warning("Please upload a file.");
          setLoading(false);
          return;
        }
        const formData = new FormData();
        formData.append('file', fileList[0].originFileObj);
        if(endpoint === 'send-to-dc-consultant'){
          values.selectedDocuments = selectedDocuments;
        }
        const data = { ...values };
        formData.append('data', JSON.stringify(data));
        response = await axios.post(endpoint, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 120000,
        });
      } else {
        // For endpoints like documentcontroller-sendback or send-to-next-user, no file is required
        if (endpoint === 'documentcontroller-sendback') {
          values.consulWithStatus = form.getFieldValue('consulWithStatus') || selectedFile.consulWithStatus;
        }
        response = await axios.post(endpoint, values);
      }
  
      // message.success('Document sent successfully!');
      // handleModalClose();
      // fetchDocuments();
      // fetchDocumentCount();
      // setLoading(false);
      // location.state.openSendModal = false
      if (response && (response.status === 200 || response.status === 201)) {
        message.success('Document sent successfully!');
        handleModalClose();
        fetchDocuments();
        fetchDocumentCount();
        
        if (location.state) {
          location.state.openSendModal = false;
        }
      }
    } catch (err) {
      if (err.response?.data?.message) {
        message.error(err.response.data.message);
      } else if (err.response?.data?.userName?.[0]) {
        message.error(err.response.data.userName[0]);
      } else if (err.response?.status === 401) {
        message.error('User not authorized');
      } else if (err.response?.status === 400) {
        message.error('Invalid request. Please check your input.');
      } else if (err.response?.status >= 500) {
        message.error('Server error. Please try again later.');
      } else if (err.code === 'ECONNABORTED') {
        message.error('Request timeout. Please try again.');
      } else {
        message.error('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  const approveByRole = async (code) => {
    let endpoint = "";
  
    // if (userType === CONTRACTOR) {
    //   endpoint = 'approve-document';
    // } else if (userType === CONSULTANT) {
    //   endpoint = "approvedBy-Consultant";
    // } 

    if (userType === CONTRACTOR || userType === CONSULTANT || userType === SUBCONTRACTOR) {
      endpoint = "approve-document";
    }

    setLoading(true);
    try {
      await axios.post(endpoint, { code, comment: approvalComment, user, role: role });
      message.success("Approved Successfully");
      fetchDocuments();
      fetchDocumentCount();
      setIsApproveModalOpen(false);
      setApprovalComment("");
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      console.error("API Error:", err.response ? err.response.data : err);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong1');
      }    
      console.error("API Error:", err.response ? err.response.data : err);
    }
  };

  const fetchDocumentCount = async () => {
    setLoading(true);
    try {
      const res = await axios.post('document-count', { role, user, projectName });
      if (res && res.data) {
          setPendingCount(res.data.pendingCount);
        } 
      if(res && res.data) {
          setApprovedCount(res.data.approvedCount);
      }
      setLoading(false);

    } catch (err) {
      setLoading(false);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong');
      }    }
  };
  
  const fetchDocuments = async () => {
    try {
      setLoading(true);

      const res = await axios.post('get-all-documents', {role, user, projectName, userType})
      if (res && res.data && res.data.documents && res.data.documents) {
        setDocuments(res.data.documents);
        const reformattedArray = res.data.documents.map(({ projectName }) => ({ 'text': projectName, 'value': projectName }));
				const unique = [];
				reformattedArray.map(x => unique.filter(a => a.text === x.text && a.value === x.value).length > 0 ? null : unique.push(x));
				setFilters(unique);
      }
      setLoading(false);

    } catch (err) {
      setLoading(false);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong');
      }
    }
  };

  // useEffect(() => {
  //   fetchDocuments()
  //   fetchDocumentCount();
  // }, []);
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    fetchDocuments();
    fetchDocumentCount();
  }, []);

  const handleRejectSubmit = async () => {
    if (!rejectReason.trim()) {
      message.error("Please provide a reason for rejection.");
      return;
    }

    try {
      setIsRejectLoading(true);
      if(userType === CONSULTANT){
        await axios.post('reject-document-by-dmconsultant', {code: selectedFile.code, role, user, rejectReason:rejectReason, sendToRole: rejectSendTo});
      } else{
  
      const rejectedDocumentFile = fileList[0]?.originFileObj;
    
      const formData = new FormData();
      if (rejectedDocumentFile) {
        formData.append("file", rejectedDocumentFile);
      }
      formData.append("data", JSON.stringify({ code: selectedFile.code, role, user, rejectReason:rejectReason, revision: selectedFile.revision }));
      setIsRejectLoading(true);
      const response = await axios.post('reject-document', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
  
      message.success( "Rejection submitted successfully!");
      setRejectReason('');
      setFileList([]);
      handleUploadModalClose();
      fetchDocuments();
      fetchDocumentCount();
      setSelectedFile(null);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong');
      }
    } finally {
      setIsRejectLoading(false);
    }
  };

  const getUniqueFilters = (key) => {
    return [...new Set(documents.map((doc) => doc[key]))]
      .filter(Boolean)
      .map((value) => ({ text: value, value }));
  };

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedDocuments(selectedRows.map(row => ({
      documentReference: row.documentReference,
      documentDescription: row.documentDescription,
      code: row.code,
      category: row.category
    })));
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: 'Document Reference',
      dataIndex: 'documentReference',
      key: 'documentReference',
      width: 180,
      ellipsis: {
        showTitle: false,
      },
      filters: getUniqueFilters('documentReference'),
      onFilter: (value, record) => record.documentReference?.startsWith(value),
      filterSearch: true,
      render: (text, record) =>
        text ? (
          <Tooltip title={text}>
            <a
              onClick={(e) => {
                e.preventDefault();

                if (record.canAccess) {
                  navigate(`document/${encodeURIComponent(record.documentReference)}`, {
                    state: record,
                  });
                } else {
                  Modal.warning({
                    title: "Access Restricted",
                    content: "You are not in the workflow.",
                  });
                }
              }}
              className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer font-medium text-sm leading-5"
              style={{
                display: "block",
                wordBreak: "break-word",
                whiteSpace: "normal",
                lineHeight: "1.4",
              }}
            >
              {text}
            </a>
          </Tooltip>
        ) : (
          <span className="text-gray-500 text-sm">NA</span>
        ),

    },
    {
      title: 'Description',
      dataIndex: 'documentDescription',
      key: 'documentDescription',
      width: 170,
      ellipsis: {
        showTitle: false,
      },
      render: (text) => (
        <Tooltip title={text || 'No description available'}>
          <div 
            className="text-sm text-gray-800 leading-5"
            style={{ 
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              lineHeight: '1.4',
              maxHeight: '60px',
              overflow: 'hidden'
            }}
          >
            {text || <span className="text-gray-500">NA</span>}
          </div>
        </Tooltip>
      )
    },
    {
      title: 'Discipline',
      dataIndex: 'discipline',
      key: 'discipline',
      width: 120,
      filters: getUniqueFilters('discipline'),
      onFilter: (value, record) => record.discipline?.startsWith(value),
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
      render: (text) => (
        <Tooltip title={text}>
          <span className="text-sm font-medium text-gray-700" style={{ lineHeight: '1.4' }}>
            {text || <span className="text-gray-500">NA</span>}
          </span>
        </Tooltip>
      )
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 140,
      filters: getUniqueFilters('type'),
      onFilter: (value, record) => record.type?.startsWith(value),
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
      render: (text) => {
        const displayText = text ? text.split(" (")[0] : 'NA';
        return (
          <Tooltip title={text || 'No type specified'}>
            <span 
              className="text-sm text-gray-700"
              style={{ 
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                lineHeight: '1.4'
              }}
            >
              {displayText === 'NA' ? <span className="text-gray-500">NA</span> : displayText}
            </span>
          </Tooltip>
        );
      }
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      width: 140,
      filters: getUniqueFilters('category'),
      onFilter: (value, record) => record.category?.startsWith(value),
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
      render: (text) => {
        const displayText = text ? text.split(" (")[0] : 'NA';
        return (
          <Tooltip title={text || 'No category specified'}>
            <span 
              className="text-sm text-gray-700"
              style={{ 
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                lineHeight: '1.4'
              }}
            >
              {displayText === 'NA' ? <span className="text-gray-500">NA</span> : displayText}
            </span>
          </Tooltip>
        );
      }
    },
    {
      title: 'Unread Message',
      dataIndex: 'unreadCount',
      key: 'unreadCount',
      width: 100,
    },
    {
      title: 'Uploaded Date',
      dataIndex: 'uploadedDate',
      key: 'uploadedDate',
      width: 120,
      render: (text) => (
        <Tooltip title={text ? moment(text).format('DD/MM/YYYY HH:mm:ss') : 'No upload date'}>
          <span className="text-sm text-gray-700" style={{ lineHeight: '1.4' }}>
            {text ? moment(text).format('DD/MM/YYYY HH:mm') : <span className="text-gray-500">NA</span>}
          </span>
        </Tooltip>
      )
    },
    userType === CONTRACTOR && {
      title: 'Revision',
      dataIndex: 'version',
      key: 'version',
      width: 100,
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => (
        <Tooltip title={`Revision: ${text || 'Not specified'}`}>
          <span className="text-sm font-medium text-gray-700" style={{ lineHeight: '1.4' }}>
            {text || <span className="text-gray-500">NA</span>}
          </span>
        </Tooltip>
      )
    },
    userType === CONSULTANT && {
      title: 'Revision',
      dataIndex: 'revision',
      key: 'revision',
      width: 100,
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => (
        <Tooltip title={`Revision: ${text || 'R0'}`}>
          <span className="text-sm font-medium text-gray-700" style={{ lineHeight: '1.4' }}>
            {text || 'R0'}
          </span>
        </Tooltip>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      filters: getUniqueFilters('status'),
      onFilter: (value, record) => record.status?.startsWith(value),
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
      render: (text, row) => {
        const statusText = userType === CONSULTANT 
          ? (row.externalStatus || 'Internal Review')
          : (row.status || 'NA');
        const getStatusColor = (status) => {
          if (status === "Uploaded" || status === "Approved") {
            return "text-green-600";
          }
          if (status === "Approved with Comments") {
            return "text-yellow-700";
          }
          if (status === "Rejected" || status === "Revise & Resubmit") {
            return "text-red-600";
          }
          if (status === "Under Internal Review") {
            return "text-blue-600";
          }
          return "text-gray-800 bg-gray-50";
        };


        return (
          <Tooltip title={statusText}>
            <span 
              className={`text-sm font-medium px-2 py-1 rounded-md ${getStatusColor(statusText)}`}
              style={{ 
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                lineHeight: '1.4',
                display: 'inline-block'
              }}
            >
              {statusText}
            </span>
          </Tooltip>
        );
      }
    },
    {
      title: 'WorkFlow Stage',
      dataIndex: 'stage',
      key: 'stage',
      width: 180,
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => (
        <Tooltip title={text || 'No workflow stage specified'}>
          <span 
            className="text-sm text-gray-700"
            style={{ 
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              lineHeight: '1.4'
            }}
          >
            {text || <span className="text-gray-500">NA</span>}
          </span>
        </Tooltip>
      )
    },
    (role.includes(DRAUGHTSMAN) || role.includes(ENGINEER) || role.includes(QUANTITY_SURVEYOR) || role.includes(PLANNING_ENGINEER) || role.includes(DOCUMENT_CONTROLLER) ||
      role.includes(HEALTH_SAFETY_ENVIRONMENT) || role.includes(CONSULTANT_ENGINEER) || role.includes(CONSULTANT_SITE_ENGINEER) ||
      role.includes(CONSULTANT_QUANTITY_SURVEYOR) || role.includes(CONSULTANT_SUPERVISOR) || role.includes(CONSULTANT_HEALTH_SAFETY_ENVIRONMENT) ||
      role.includes(CONSULTANT_DESIGN_MANAGER)) && {
      title: 'Revision Required',
      key: 'rejectDocument',
      width: 240,
      render: (text, record) => (
        ["Revise & Resubmit", "Rejected", "Under Internal Review"].includes(record.status) ? (
          record.uploadedBy === user  && record.stage === role ? <div className="flex flex-wrap gap-2 items-center">
            {record.rejectionReasons[record.rejectionReasons?.length - 1]?.rejectedDocumentUrl &&
              <Button 
                type="primary" 
                size="small"
                onClick={() => handleRejectedDocPreview(record)}
                className="text-xs font-medium"
                style={{ minWidth: '80px' }}
              >
                Compare
              </Button>
            }
            <Button
              type="default"
              size="small"
              onClick={() => handleReupload(record)}
              className="text-xs font-medium bg-blue-50 text-blue-600 border-blue-300 hover:bg-blue-100"
              style={{ minWidth: '90px' }}
            >
              RE-UPLOAD
            </Button>  
          </div> : <span className="text-gray-500 text-sm">-</span>
        ) : (
          <span className="text-gray-500 text-sm">-</span>
        )
      )
    }, 
    {
      title: 'Actions',
      key: 'actions',
      width: 200,
      fixed: 'right',
      render: (text, record) => {
        return (
          <div className="flex flex-wrap gap-2 items-center justify-start">
            {/* Download Button */}
            {record.canAccess ? (<><Tooltip title="Download document">
              <Button
                icon={<DownloadOutlined />}
                onClick={() => handleDownload(userType === CONSULTANT ? record.docWithTransmittal : record.documentUrl)}
                size="small"
                className="bg-white text-blue-600 border-blue-300 hover:bg-blue-50" />
            </Tooltip><Tooltip title="Preview document">
                <Button
                  icon={<EyeOutlined />}
                  onClick={() => handlePreview(userType === CONSULTANT ? record.docWithTransmittal : record.documentUrl)}
                  size="small"
                  className="bg-white text-gray-700 border-gray-300 hover:bg-gray-50" />
              </Tooltip></>) : '-' }
  
            {/* Send Button */}
            {!record.hasResponse && 
              !record?.status?.includes('Approved by Consultant') && !record?.status?.includes('Approved with Comments') && !record?.status?.includes('Approved') &&
              (
                (role.includes("Manager") && record.approvedDetails?.[role]?.approved === true && record.stage?.trim().toLowerCase() === role?.trim().toLowerCase()) ||
                (record.uploadedBy === user && !record?.status?.includes('Revise') && !record?.status?.includes('Rejected') && !record.sentDetails?.[role]?.sent && record.stage?.trim().toLowerCase() === role?.trim().toLowerCase()) ||
                (!role.includes("Manager") && record.uploadedBy !== user && !record.sentDetails?.[role]?.sent && record.stage?.trim().toLowerCase() === role?.trim().toLowerCase())
              ) && 
              (
                <Tooltip title="Send document">
                  <Button
                    icon={<SendOutlined />}
                    onClick={() => handleOpenModal(record)}
                    size="small"
                    className="bg-white text-green-600 border-green-300 hover:bg-green-50"
                  />
                </Tooltip>
            )}
  
            {/* Pending Status Actions */}
            {((!record?.status?.includes('Rejected') &&  userType === CONTRACTOR) || userType === CONSULTANT) &&  (
              <>
                {(
                  // Manager case
                  (role.includes('Manager') && !record.approvedDetails?.[role]?.approved && record.stage?.trim().toLowerCase() === role?.trim().toLowerCase()) ||
  
                  // Other roles case
                  (!record.uploadedBy === user &&
                  !role.includes('Document') &&
                  record.timelineDetails?.[role]?.date &&
                  !record.approvedDetails?.[role]?.approved &&
                  record.stage === role)
                ) && (
                  <>
                    {/* Approve Button */}
                    <Tooltip title="Approve document">
                      <Button
                        icon={<CheckCircleOutlined />}
                        onClick={() => handleOpenApproveModal(record)}
                        size="small"
                        className="bg-white text-green-600 border-green-300 hover:bg-green-50"
                        disabled={record.approvedDetails?.[role]?.approved}
                      />
                    </Tooltip>
  
                    {/* Reject Button */}
                    <Tooltip title="Reject document">
                      <Button
                        icon={<CloseCircleOutlined />}
                        onClick={() => handleUploadModalOpen(record)}
                        size="small"
                        className="bg-white text-red-600 border-red-300 hover:bg-red-50"
                        disabled={record.approvedDetails?.[role]?.approved}
                      />
                    </Tooltip>
                  </>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ].filter(Boolean);

  const allColumns = columns.filter(Boolean); 
  const [visibleColumnKeys, setVisibleColumnKeys] = useState(allColumns.map(col => col.key));
  const filteredColumns = allColumns.filter(col => visibleColumnKeys?.includes(col.key));

  const handleDropdownVisibilityChange = (visible) => {
    setDropdownVisible(visible);
  };

  const sendToUser = async ( documentReference ) => {
    try {
			const res = await axios.post('get-send-to-user', { user, documentReference });
			if (res && res.data && res.data.sendToRoles) {
        if(res.data.sendToRoles.length === 1){
				  form.setFieldValue('sendTo', res.data.sendToRoles[0]);
          setSendToOptions(res.data.sendToRoles);
        } else {
          setSendToOptions(res.data.sendToRoles);
        }
			}
		} catch (err) {
			if (err.response && err.response.data && err.response.data.msg) {
				message.warning(err.response.data.msg);
			} else if (err.response && err.response.data && err.response.data.userName) {
				message.warning(err.response.data.userName[0]);
			} else if (err.response && err.response.status === 401) {
				message.error('User not authorised');
			} else {
				message.error('Something went wrong');
			}
		}
  }

  const getSendToRoles = async () => {
    try {
			const res = await axios.post('get-send-to-roles', { user });
			if (res && res.data && res.data.userRoles) {
				setRoles(res.data.userRoles);
			}
		} catch (err) {
			if (err.response && err.response.data && err.response.data.msg) {
				message.warning(err.response.data.msg);
			} else if (err.response && err.response.data && err.response.data.userName) {
				message.warning(err.response.data.userName[0]);
			} else if (err.response && err.response.status === 401) {
				message.error('User not authorised');
			} else {
				message.error('Something went wrong');
			}
		}
  }

  useEffect(() => {
    loadPreference();
  }, []);

   const loadPreference = async () => {
    const res = await axios.post("/get-column-preferences", { username: user, projectName });

    if (res.data?.visibleColumns?.length) {
      setVisibleColumnKeys(res.data.visibleColumns);
    }
  };
 
  const saveColumnPreference = async () => {
    try {
      await axios.post("/save-column-preferences", {
        username: user,
        projectName,
        visibleColumns: visibleColumnKeys,
      });
      setDropdownVisible(false)
      message.success("Column preference saved");
    } catch (err) {
			if (err.response && err.response.data && err.response.data.msg) {
				message.warning(err.response.data.msg);
			} else if (err.response && err.response.data && err.response.data.userName) {
				message.warning(err.response.data.userName[0]);
			} else if (err.response && err.response.status === 401) {
				message.error('User not authorised');
			} else {
				message.error('Something went wrong');
			}
		}
  };

  return (   
    <div className="relative flex-1 p-3 overflow-y-auto min-h-screen ml-6 mr-1">
      <div className="flex justify-between items-start mb-6">
        <div className="flex space-x-4 sm:space-x-6">
          {(role.includes(DESIGN_MANAGER) || role.includes(PROJECT_MANAGER)) && (
            <>
              <div className="flex space-x-4">
                {/* Pending Card */}
                <div 
                  className="w-64 bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl border border-amber-200 shadow-lg p-5 
                    transition-all duration-300 hover:shadow-xl hover:translate-y-[-4px]"
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      <HourglassTwoTone twoToneColor="#F59E0B" style={{ fontSize: "28px" }} />
                      <h2 className="text-lg font-semibold text-amber-800 ml-3">Pending Review</h2>
                    </div>
                  </div>
                  <div className="flex items-end justify-between">
                    <p className="text-4xl font-bold text-amber-700">{pendingCount}</p>
                    <div className="text-amber-600 text-sm">
                      {pendingCount > 0 ? 'Requires attention' : 'All clear'}
                    </div>
                  </div>
                </div>

                {/* Approved Card */}
                <div 
                  className="w-64 bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl border border-teal-200 shadow-lg p-5 
                    transition-all duration-300 hover:shadow-xl hover:translate-y-[-4px]"
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      <CheckCircleTwoTone twoToneColor="#14B8A6" style={{ fontSize: "28px" }} />
                      <h2 className="text-lg font-semibold text-teal-800 ml-3">Approved</h2>
                    </div>
                  </div>
                  <div className="flex items-end justify-between">
                    <p className="text-4xl font-bold text-teal-700">{approvedCount}</p>
                    <div className="text-teal-600 text-sm">
                      Documents finalized
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Document Table Card */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        {/* Header with Customize View */}
        <div className="flex items-center justify-between px-3 py-2 border-b border-gray-200">

          <div className="flex items-center space-x-3">
            <Dropdown
              trigger={['click']}
              open={dropdownVisible}
              onOpenChange={handleDropdownVisibilityChange}
              dropdownRender={() => (
                <div
                  className="p-2 bg-white rounded-md shadow-lg border"
                  onClick={(e) => e.stopPropagation()} // ⭐ critical
                >
                  <div className="px-4 py-2 text-lg font-medium text-gray-700 border-b mb-2">
                    Visible Columns
                  </div>

                  {allColumns.map((col) => (
                    <div key={col.key} className="px-3 py-1">
                      <Checkbox
                        checked={visibleColumnKeys.includes(col.key)}
                        onChange={() =>
                          setVisibleColumnKeys((prev) =>
                            prev.includes(col.key)
                              ? prev.filter((key) => key !== col.key)
                              : [...prev, col.key]
                          )
                        }
                      >
                        {col.title}
                      </Checkbox>
                    </div>
                  ))}

                  <div className="px-3 pt-3">
                    <Button
                      type="primary"
                      block
                      className="bg-indigo-500 hover:bg-indigo-600"
                      onClick={() => {
                        saveColumnPreference();
                        setDropdownVisible(false); // optional: close after save
                      }}
                    >
                      Save View
                    </Button>
                  </div>
                </div>
              )}
            >
              <Button
                icon={<SettingOutlined />}
                className="flex items-center font-medium px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-100"
              >
                <span className="ml-2">Customize View</span>
              </Button>
            </Dropdown>
          </div>

          <div className="flex items-center gap-3">

            {(role.includes(CONSULTANT_DOCUMENT_CONTROLLER) || role.includes(DOCUMENT_CONTROLLER)) && 
              selectedRowKeys.length === 1 &&  selectedDocuments[0]?.category === 'Correspondences (LTR)' && (
                <Button
                  type="primary"
                  icon={<UploadOutlined />}
                  className="bg-blue-500 hover:bg-blue-600"
                  onClick={() => {
                    if (!selectedDocuments.length) {
                      message.warning("Please select a document first");
                      return;
                    }

                    const doc = documents.find(d => d.code === selectedDocuments[0].code);

                    navigate("/home/upload-document", {
                      state: {
                        from: "upload-response",
                        prefillData: {
                          type: doc.type,
                          category: doc.category,
                          discipline: doc.discipline,
                          respondingTo: doc.documentReference, // ⭐ key point
                          originalDocumentCode: doc.code,
                          projectName: doc.projectName,
                        }
                      }
                    });
                  }}
                >
                  Upload Response
                </Button>
              )
            }

            {/* {(role.includes(CONSULTANT_DOCUMENT_CONTROLLER) || role.includes(DOCUMENT_CONTROLLER)) &&
              isSingleSelection && (
                <Button
                  type="primary"
                  icon={<UploadOutlined />}
                  className="bg-blue-500 hover:bg-blue-600"
                  onClick={() => {
                    const doc = documents.find(d => d.code === selectedDocuments[0].code);

                    navigate("/home/upload-document", {
                      state: {
                        from: "upload-response",
                        prefillData: {
                          type: doc.type,
                          category: doc.category,
                          discipline: doc.discipline,
                          respondingTo: doc.documentReference,
                          originalDocumentCode: doc.code,
                          projectName: doc.projectName,
                        }
                      }
                    });
                  }}
                >
                  Upload Response
                </Button>
            )} */}

            {selectedRowKeys.length > 0 && (
              <Button
                type="primary"
                onClick={() => navigate('/home/transmittal-template', { state: { selectedDocuments },
                  })
                }
                className="bg-green-500 hover:bg-green-600"
              >
                Create Transmittal
              </Button>
            )}

          </div>
        </div>

        {/* Table */}
        <Table
          rowSelection={role.includes(DOCUMENT_CONTROLLER) ? rowSelection : undefined}
          columns={filteredColumns.map(col => ({
            ...col,
            className: 'py-4',
            render: col.render || (text => {
              if (col.key === 'status') {
                const statusColors = {
                  'Pending': 'bg-yellow-100 text-yellow-800 border-yellow-300',
                  'Approved': 'bg-green-100 text-green-800 border-green-300',
                  'Rejected': 'bg-red-100 text-red-800 border-red-300',
                  'In Review': 'bg-blue-100 text-blue-800 border-blue-300'
                };
                const color = statusColors[text] || 'bg-gray-100 text-gray-800 border-gray-300';
                return (
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${color}`}>
                    {text}
                  </span>
                );
              }
              return text;
            })
          }))}
          dataSource={documents}
          rowKey="documentReference"
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} documents`,
            onChange: (page, pageSize) => {
              setPagination({ current: page, pageSize });
            },
          }}
          loading={loading}
          rowClassName="hover:bg-gray-50"
        />
      </div>

      <Modal
        title={
          <div className="text-center py-2">
            <div className="flex justify-center mb-2">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full">
                <SendOutlined style={{ fontSize: "24px", color: "#3B82F6" }} />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-800">Send Document</h3>
          </div>
        }
        open={isModalOpen}
        onCancel={handleModalClose}
        footer={null}
        destroyOnClose
        width={500}
        bodyStyle={{ padding: '24px' }}
      >
        <Form 
          form={form} 
          onFinish={sendDocument}
          layout="vertical"
          initialValues={{
            timeline: dayjs().add(1, 'day'),
            sendTo: undefined,
          }}
        >
          {/* Select Roles Form Item */}
          <Form.Item
            label="Send To"
            name="sendTo"
            rules={[{ required: true, message: 'Please select recipient(s)' }]}
          > 
            {((role.includes(DOCUMENT_CONTROLLER) && userType === CONTRACTOR) || 
              (role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER) && userType === SUBCONTRACTOR)
            ) ? (
              
              <Select 
                className="w-full"  
                placeholder={fetchingRoles ? "Loading roles..." : "Select recipients"}
                suffixIcon={<TeamOutlined />}
                onChange={(value) => setSelectedRole(value)}
                // loading={fetchingRoles}
                // value={selectedRole}
              >
                {availableRoles.map((roleItem) => (
                  <Option key={roleItem} value={roleItem}>
                    {roleItem}
                  </Option>
                ))}
                <Option key="email" value="email">
                  Email
                </Option>

             </Select>
             
            ) : role.includes("Consultant") ? (
              <Select 
                className="w-full"
                placeholder={fetchingRoles ? "Loading roles..." : "Select recipients"}
                suffixIcon={<TeamOutlined />}
                onChange={(value) => setSelectedRole(value)}
                loading={fetchingRoles}
                value={selectedRole}
              >
                {roles
                .filter((e) => e.role !== CONSULTANT_DOCUMENT_CONTROLLER)
                .map((e) => (
                  <Option key={e.role} value={e.role}>
                    {e.role}
                  </Option>
                ))}
              </Select>
            ) : (
               <Select
                className="w-full"
                placeholder={sendToOptions.length === 0 ? "No recipients available" : "Select recipients"}
                suffixIcon={<LockOutlined />}
                onChange={(value) => form.setFieldValue("sendTo", value)}
                value={form.getFieldValue("sendTo")}
                // disabled={sendToOptions.length === 0}
              >
                {sendToOptions.map((role) => (
                  <Option key={role} value={role}>
                    {role}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>

          {!(role?.includes(DOCUMENT_CONTROLLER) || (selectedRole?.includes && selectedRole?.includes('Document'))) && (
            <Form.Item
              label="Required By Date"
              name="timeline"
              rules={[{ required: true, message: 'Please set due date' }]}
            >
              <DatePicker
                format="YYYY-MM-DD"
                onChange={(date) => setTimeline(date ? date.format("YYYY-MM-DD") : "")}
                style={{ width: '100%' }}
                disabledDate={(current) => current && current < dayjs().startOf('day')}
                placeholder="Select due date"
                suffixIcon={<CalendarOutlined />}
              />
            </Form.Item>
          )}
          {(role.includes(DOCUMENT_CONTROLLER) && selectedRole === "email") && (
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Please enter an email address' },
                { type: 'email', message: 'Please enter a valid email address' }
              ]}
            >
              <Input
                placeholder="Enter email address"
                className="w-full "
              />
            </Form.Item>
          )}
          {role.includes(DOCUMENT_CONTROLLER) && (selectedRole?.includes(CONSULTANT_DOCUMENT_CONTROLLER) || selectedRole?.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER) || selectedRole === "email") && (
            <Form.Item label="Upload Transmittal Document" name="file"
              rules={[{ required: true, message: 'Please upload a transmittal document'}]} >
              <Upload 
                fileList={fileList}
                maxCount={1}
                beforeUpload={() => false}
                onChange={({ fileList }) => setFileList(fileList)}
                className="w-full"
                accept=".pdf"
              >
                <Button 
                icon={<UploadOutlined />}
                className="w-full h-12 flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white"
              >
                Select File
                </Button>
              </Upload>
            </Form.Item>
          )}
          {(role.includes(CONSULTANT_DOCUMENT_CONTROLLER) || role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER)) && selectedRole?.includes(DOCUMENT_CONTROLLER) && (
            <>
              <Form.Item
                label="Comment"
                name="consulWithStatus"
                rules={[{ required: true, message: 'Please select a status' }]}
              >
                <Select placeholder="Select status" className="w-full h-9">
                  <Select.Option value="Approved">Approved</Select.Option>
                  <Select.Option value="Approved with Comments">Approved with Comments</Select.Option>
                  <Select.Option value="Revise & Resubmit">Revise & Resubmit</Select.Option>
                  <Select.Option value="Rejected">Rejected</Select.Option>
                  <Select.Option value="For Information">For Information</Select.Option>
                  <Select.Option value="Responded">Responded</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Upload Document"
                name="file"
                rules={[{ required: true, message: 'Please upload a document' }]}
              >
                <Upload
                  fileList={fileList}
                  maxCount={1}
                  beforeUpload={() => false}
                  onChange={({ fileList }) => setFileList(fileList)}
                  className="w-full"
                  accept=".pdf,.doc,.docx"
                >
                  <Button
                    icon={<UploadOutlined />}
                    className="w-full h-12 flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white"
                  >
                    Select File
                  </Button>
                </Upload>
              </Form.Item>
            </>
          )}
          
          {/* Submit Button */}
          <div className="flex justify-center">
            <Button 
              type="primary" 
              htmlType="submit" 
              className="w-1/4 mt-4" 
              style={{ backgroundColor: 'green', color: 'white' }} 
              loading={loading}
            >
              SEND
            </Button>
          </div>
        </Form>
      </Modal>
 
      <Modal
        title={
          <div className="text-center py-2">
            <div className="flex justify-center mb-2">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full">
                <CheckOutlined style={{ fontSize: "24px", color: "#16A34A" }} />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-800">Document Approval</h3>
          </div>
        }
        visible={isApproveModalOpen}
        onCancel={() => setIsApproveModalOpen(false)}
        footer={null}
        width={500}
        bodyStyle={{ padding: '24px' }}
      >
        <div className="mb-6">
          <Radio.Group 
            onChange={(e) => setApprovalType(e.target.value)} 
            value={approvalType}
            className="w-full grid grid-cols-2 gap-4"
          >
            <div className={`border rounded-lg p-4 ${approvalType === 'approve' ? 'border-green-500 bg-green-50' : 'border-gray-300'}`}>
              <Radio value="approve" className="w-full">
                <div className="ml-2">
                  <div className="font-medium">Approve</div>
                  <div className="text-sm text-gray-500">No changes needed</div>
                </div>
              </Radio>
            </div>
            
            <div className={`border rounded-lg p-4 ${approvalType === 'approveWithComment' ? 'border-blue-500 bg-blue-50' : 'border-gray-300'}`}>
              <Radio value="approveWithComment" className="w-full">
                <div className="ml-2">
                  <div className="font-medium">With Comments</div>
                  <div className="text-sm text-gray-500">Add feedback</div>
                </div>
              </Radio>
            </div>
          </Radio.Group>
        </div>

        {approvalType === "approveWithComment" && (
          <div className="mt-4 mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Your Comments</label>
            <Input.TextArea
              rows={4}
              placeholder="Add your feedback or comments"
              value={approvalComment}
              onChange={(e) => setApprovalComment(e.target.value)}
              className="w-full border-gray-300 rounded-md"
            />
          </div>
        )}
    
        <div className="flex justify-center">
          <Button 
            type="primary" 
            onClick={handleApproveWithComment}
            className="w-full py-2 h-auto text-base font-medium" 
            style={{ background: '#16A34A' }}
            loading={loading}
          >
            Confirm Approval
          </Button>
        </div>
      </Modal>


      {/* Modal for Preview */}
      <Modal
        title={
          <div className="flex justify-between items-center py-3">
            <h3 className="text-lg font-semibold">
              {isComparisonView ? "Document Comparison" : "Document Preview"}
            </h3>

            {isComparisonView && (
              <Button
                icon={<LeftOutlined />}
                onClick={() => setIsComparisonView(false)}
              >
                Back to Preview
              </Button>
            )}
          </div>
        }
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width="80vw"                 // 🔽 reduced width
        style={{ top: 40 }}          // 🔽 slightly lower
        bodyStyle={{
          padding: 0,
          height: "75vh",            // 🔽 reduced height
          overflow: "hidden"
        }}
        destroyOnClose
      >
        {isComparisonView ? (
          <div className="flex h-full">
            {/* LEFT DOCUMENT */}
            <div className="w-1/2 border-r border-gray-300 h-full">
              <div className="bg-gray-100 p-3 text-center font-semibold border-b flex items-center justify-center">
                <FileTextOutlined className="mr-2" />
                Original Document
              </div>

              <iframe
                src={originalDocUrl}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="Original Document"
              />
            </div>

            {/* RIGHT DOCUMENT */}
            <div className="w-1/2 h-full">
              <div className="bg-gray-100 p-3 text-center font-semibold border-b flex items-center justify-center">
                <FileExclamationOutlined className="mr-2" />
                Rejected Version
              </div>

              <iframe
                src={fileUrl}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="Rejected Document"
              />
            </div>
          </div>
        ) : (
          <div className="h-full">
            <iframe
              src={fileUrl}
              width="100%"
              height="100%"
              style={{ border: "none" }}
              title="Document Preview"
            />
          </div>
        )}
      </Modal>

      <Modal
        title={
          <div className="text-center py-2">
            <div className="flex justify-center mb-2">
              <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-full">
                <CloseCircleOutlined style={{ fontSize: "24px", color: "#DC2626" }} />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-800">Reject Document</h3>
          </div>
        }
        visible={isUploadModalOpen}
        onCancel={handleUploadModalClose}
        footer={null}
        destroyOnClose={true}
        width={500}
        bodyStyle={{ padding: '24px' }}
      >
        <Form layout="vertical" preserve={false}>
          {userType === CONSULTANT && (
            <Form.Item 
              label="Send To" 
              required
            >
              <Select
                placeholder="Select role"
                value={rejectSendTo}
                onChange={(value) => setRejectSendTo(value)}
              >
                {rejectOptions.map((r) => (
                  <Option key={r} value={r}>
                    {r}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {/* Reason Input */}
          <Form.Item 
            label="Rejection Reason" 
            name="rejectionreason" 
            rules={[{ required: true, message: 'Please provide a reason for rejection' }]}
          >
            <Input.TextArea
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Explain why this document is being rejected"
              rows={4}
              className="w-full border-gray-300 rounded-md"
            />
          </Form.Item>

          {/* File Upload */}
          {!role.includes(DOCUMENT_CONTROLLER) && userType === CONTRACTOR && (
            <Form.Item 
              label="Upload Edited Document" 
              name="file"
              // rules={[{ required: false, message: 'Please upload edited document' }]} 
            >
              <Upload 
                fileList={fileList}
                maxCount={1}
                beforeUpload={() => false}
                onChange={({ fileList }) => setFileList(fileList)}
                className="w-full"
              >
                <Button 
                  icon={<UploadOutlined />}
                  className="w-full h-12 flex items-center justify-center bg-red-50 text-red-600 border border-red-300 hover:bg-red-100"
                >
                  Select Revised Document
                </Button>
              </Upload>
            </Form.Item>
          )}

          {/* Submit Button */}
          <div className="flex justify-center mt-6">
            <Button 
              type="primary"  
              onClick={handleRejectSubmit}
              className="w-full py-2 h-auto text-base font-medium" 
              style={{ background: '#DC2626' }}
              loading={isRejectLoading}
            >
              {isRejectLoading ? 'Uploading...' : 'Submit Rejection'}
            </Button>
          </div>
        </Form>
      </Modal>

    </div>
  );
};

export default ViewDocumentPage;